import { QueryClient } from "@tanstack/react-query";

/*
 * TanStack Query owns all server state. This replaces the useState + useEffect
 * + loading-flag + setInterval plumbing the Next.js app hand-rolled on every
 * data page — dashboard/page.js alone had three fetchers and a 120-second
 * countdown before any UI.
 *
 * Two defaults worth knowing:
 *
 *   refetchOnWindowFocus: false
 *       Tracking data changes on a fixed cadence (the desktop app uploads every
 *       few minutes), not on tab focus. Refetching on focus would hammer the API
 *       every time an admin alt-tabs, for data that cannot have changed.
 *
 *   refetchIntervalInBackground: false  (the library default — stated here on
 *       purpose) Pages that poll set their own refetchInterval; leaving this
 *       false pauses polling on a hidden tab. The Next.js countdown did NOT do
 *       this, so a backgrounded dashboard polled forever.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            retry: (failureCount, error) => {
                // Never retry an auth or permission failure — the interceptor
                // has already cleared the session and redirected.
                const status = error?.response?.status;
                if (status === 401 || status === 403 || status === 404) return false;
                return failureCount < 2;
            },
        },
        mutations: {
            retry: 0,
        },
    },
});
